export const getProduct = (products, key, val) => {
    return products.find((product) => product[key] === val);
};

export default getProduct;
